"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.close = exports.chevronUp = exports.chevronRight = exports.chevronLeft = exports.chevronDown = exports.checkmark = exports.check = exports.chart = exports.block = exports.arrow = exports.arrowDown = exports.add = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var add = function add(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement("path", {
      className: "outter",
      d:
        "M16 30.933c8.247 0 14.933-6.686 14.933-14.933S24.247 1.067 16 1.067C7.752 1.067 1.066 7.753 1.066 16S7.752 30.933 16 30.933z",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /*#__PURE__*/ _react["default"].createElement("path", {
      className: "inner",
      d: "M16 22.4V9.6M9.6 16h12.8H9.6z",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  );
};

exports.add = add;
add.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#070707"
};

var arrowDown = function arrowDown(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement(
      "g",
      {
        clipPath: "url(#a)"
      },
      /*#__PURE__*/ _react["default"].createElement("path", {
        d: "M.86 2.605L4.052 5.8l3.193-3.194",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    ),
    /*#__PURE__*/ _react["default"].createElement(
      "defs",
      null,
      /*#__PURE__*/ _react["default"].createElement(
        "clipPath",
        {
          id: "a"
        },
        /*#__PURE__*/ _react["default"].createElement("path", {
          fill: "#fff",
          d: "M0 0h8v8H0z"
        })
      )
    )
  );
};

exports.arrowDown = arrowDown;
arrowDown.defaultProps = {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var arrow = function arrow(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement("path", {
      d: "M2 10.485l8.485 8.486 8.486-8.486",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  );
};

exports.arrow = arrow;
arrow.defaultProps = {
  width: "21",
  height: "21",
  viewBox: "0 2 21 21",
  stroke: "red",
  xmlns: "http://www.w3.org/2000/svg"
};

var block = function block(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement("path", {
      d: "M9 17.438A8.438 8.438 0 1 0 9 .561a8.438 8.438 0 0 0 0 16.875zM14.625 3.938L3.375 14.624"
    })
  );
};

exports.block = block;
block.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var chart = function chart(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement("path", {
      d:
        "M1.334 10.896h-.5a.5.5 0 0 1 .5-.5v.5zm21.833 11.77a.5.5 0 1 1-1 0h1zm-21.333 0a.5.5 0 1 1-1 0h1zm4.138-11.77v-.5a.5.5 0 0 1 .5.5h-.5zm.5 11.77a.5.5 0 1 1-1 0h1zm3.71 0a.5.5 0 1 1-1 0h1zm-.5-16.184h-.5a.5.5 0 0 1 .5-.5v.5zm4.637 0v-.5a.5.5 0 0 1 .5.5h-.5zm.5 16.184a.5.5 0 1 1-1 0h1zm3.71 0a.5.5 0 1 1-1 0h1zm-.5-21.333h-.5a.5.5 0 0 1 .5-.5v.5zm4.638 0v-.5a.5.5 0 0 1 .5.5h-.5zM.834 22.666v-11.77h1v11.77h-1zm.5-12.27h4.638v1H1.334v-1zm5.138.5v11.77h-1v-11.77h1zm2.71 11.77V6.482h1v16.184h-1zm.5-16.684h4.637v1H9.683v-1zm5.137.5v16.184h-1V6.482h1zm2.71 16.184V1.333h1v21.333h-1zm.5-21.833h4.638v1H18.03v-1zm5.138.5v21.333h-1V1.333h1z",
      fill: "gray"
    })
  );
};

exports.chart = chart;
chart.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var check = function check(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement("path", {
      d:
        "M11.134.659a.5.5 0 1 1 .732.682l-7 7.5a.5.5 0 0 1-.72.013l-3.5-3.5a.5.5 0 1 1 .708-.708L4.488 7.78 11.134.66z"
    })
  );
};

exports.check = check;
check.defaultProps = {
  width: "12",
  height: "9",
  viewBox: "0 0 12 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var checkmark = function checkmark(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement("path", {
      clipRule: "evenodd",
      d:
        "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm6.669 9.744a1 1 0 0 0-1.338-1.488l-7.047 6.335L6.74 10.69a1 1 0 1 0-1.48 1.344l4.212 4.64a1 1 0 0 0 1.41.07l7.787-7z"
    })
  );
};

exports.checkmark = checkmark;
checkmark.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "-1 -1 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var chevronDown = function chevronDown(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d:
        "M.647 7.857a.5.5 0 0 1 .707 0l6.717 6.718 6.718-6.718a.5.5 0 1 1 .707.707l-7.071 7.072a.5.5 0 0 1-.707 0L.647 8.564a.5.5 0 0 1 0-.707z"
    })
  );
};

exports.chevronDown = chevronDown;
chevronDown.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 4 16 14",
  xmlns: "http://www.w3.org/2000/svg"
};

var chevronLeft = function chevronLeft(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d:
        "M8.604.411a.5.5 0 0 1 .012.707L2.018 7.953l6.834 6.598a.5.5 0 1 1-.695.72L.963 8.325a.5.5 0 0 1-.012-.707L7.897.424A.5.5 0 0 1 8.604.41z"
    })
  );
};

exports.chevronLeft = chevronLeft;
chevronLeft.defaultProps = {
  width: "17",
  height: "16",
  viewBox: "0 0 12 16",
  xmlns: "http://www.w3.org/2000/svg"
};

var chevronRight = function chevronRight(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d:
        "M7.718 15.496a.5.5 0 0 1 0-.707l6.717-6.718-6.717-6.718a.5.5 0 1 1 .707-.707l7.07 7.071a.5.5 0 0 1 0 .708l-7.07 7.07a.5.5 0 0 1-.707 0z"
    })
  );
};

exports.chevronRight = chevronRight;
chevronRight.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "4 0 14 16",
  xmlns: "http://www.w3.org/2000/svg"
};

var chevronUp = function chevronUp(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d:
        "M15.589 8.604a.5.5 0 0 1-.707.012L8.047 2.018 1.45 8.852a.5.5 0 1 1-.72-.695L7.675.963a.5.5 0 0 1 .707-.012l7.194 6.946a.5.5 0 0 1 .013.707z"
    })
  );
};

exports.chevronUp = chevronUp;
chevronUp.defaultProps = {
  width: "16",
  height: "17",
  viewBox: "0 0 16 12",
  xmlns: "http://www.w3.org/2000/svg"
};

var close = function close(props) {
  return /*#__PURE__*/ _react["default"].createElement(
    "svg",
    props,
    /*#__PURE__*/ _react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d:
        "M.646.646a.5.5 0 0 1 .708 0L9 8.293 16.646.646a.5.5 0 0 1 .708.708L9.707 9l7.647 7.646a.5.5 0 0 1-.708.708L9 9.707l-7.646 7.647a.5.5 0 0 1-.708-.708L8.293 9 .646 1.354a.5.5 0 0 1 0-.708z",
      fill: "#070707"
    })
  );
};

exports.close = close;
close.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
